//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";



//--------------- FUNÇÃO ASSÍNCRONA HANDLE LOGIN ---------------//
// Responsável por requisitar à API o Login do usuário
export default async function loginService(email, password) {

  if (email === null || password === null || email === "" || password === "") { // Validação dos campos "email" e "password"
    toast.error("Preencha todos os campos");
    return false
  }

  try {
    await api.post("/auth/login", { email, password }, { withCredentials: true });
    toast.success("Login realizado com sucesso!");
    return true;
  } catch (err) {
    toast.error("E-mail ou senha inválidos");
    return false;
  }
};